module.exports = __webpack_public_path__ + "static/media/img-emandamento-sansiro-02.9db2e953.jpg";